module.exports = __webpack_public_path__ + "img/q_contact.313ba8d1.png";